import React from 'react';
import { LuExternalLink } from 'react-icons/lu';

import { PersonOrg } from '@ndvr/customer-api';

import { ConfirmModal } from '@/components/ConfirmModal';

export const PotentialDuplicateDialog = ({
    result,
    onBack,
    onProceed,
    confirmText = 'Create anyway',
}: {
    result?: PersonOrg[];
    onBack: () => void;
    onProceed: () => void;
    confirmText?: string;
}) => (
    <ConfirmModal
        open={!!result?.length}
        onOpenChange={(open) => {
            if (!open) onBack();
        }}
        title="Possible duplicates"
        confirmText={confirmText}
        cancelText="Back to form"
        onConfirm={onProceed}
        description={
            <div className="space-y-3 text-left">
                <p>Review the existing people before continuing.</p>
                <div className="max-h-[50vh] space-y-3 overflow-y-auto">
                    {result?.map((person) => (
                        <div key={person.personOrgGUID}>
                            <a
                                className="inline-flex items-center gap-1 font-semibold underline"
                                href={`/person/${person.personOrgGUID}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {[person.firstNamePlain, person.lastNamePlain].filter(Boolean).join(' ') ||
                                    'View person'}
                                <LuExternalLink className="h-4 w-4 shrink-0" aria-hidden="true" />
                                <span className="sr-only"> (opens in a new tab)</span>
                            </a>
                            <p className="break-all">
                                {[
                                    person.primaryEmailPlain,
                                    person.otherEmailPlain,
                                    person.personalPhonePlain,
                                    person.businessPhonePlain,
                                ]
                                    .filter(Boolean)
                                    .join(' · ')}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        }
    />
);
